import { Map } from 'immutable';

import User from './scenes/User';
import UserDetails from './scenes/User/details';
import UserAdd from './scenes/User/add';
import SDM17SPG from './scenes/SDM17SPG';
import SDM17SPGDetails from './scenes/SDM17SPG/details';
import SDM18HCL from './scenes/SDM18HCL';
import SDM18HCLDetails from './scenes/SDM18HCL/details';
import SDM18MVR from './scenes/SDM18MVR';
import SDM18MVRDetails from './scenes/SDM18MVR/details';
import Remote from './scenes/Remote';
import RemoteDetails from './scenes/Remote/details';
import Issues from './scenes/Issues';
import IssueDetails from './scenes/Issues/details';
import IssueCreate from './scenes/Issues/create';
import SDM20LHT from './scenes/SDM20LHT';
import SDM20LHTDetails from './scenes/SDM20LHT/details';
import Security from './scenes/Security';
import SecurityDetails from './scenes/Security/details';

export default new Map({
    /** User */
    '/user': {
        firstPage: true,
        must_logged: true,
        component: User,
        right: 'userList',
        children: new Map({
            /* User Add */
            '/add': {
                index: 1,
                must_logged: true,
                component: UserAdd,
                right: 'userAdd'
            },
            /** User Detail */
            '/detail/:userId': {
                must_logged: true,
                component: UserDetails,
                right: 'userDetails'
            }
        })
    },
    /** Remote */
    '/SDM18HCL': {
        must_logged: true,
        component: SDM18HCL,
        right: 'SDM18HCLList',
        children: new Map({
            /** SDM18HCL Detail */
            '/detail/:SDM18HCLId': {
                must_logged: true,
                component: SDM18HCLDetails,
                right: 'SDM18HCLDetails'
            }
        })
    },

    /** SDM17SPGs */
    '/SDM17SPG': {
        must_logged: true,
        component: SDM17SPG,
        right: 'SDM17SPGList',
        children: new Map({
            /** SDM17SPG Detail */
            '/detail/:SDM17SPGId': {
                must_logged: true,
                component: SDM17SPGDetails,
                right: 'SDM17SPGDetails'
            }
        })
    },

    /** SDM18MVRs */
    '/SDM18MVR': {
        must_logged: true,
        component: SDM18MVR,
        right: 'SDM18MVRList',
        children: new Map({
            /** SDM18MVR Detail */
            '/detail/:SDM18MVRId': {
                must_logged: true,
                component: SDM18MVRDetails,
                right: 'SDM18MVRDetails'
            }
        })
    },

    /** remote */
    '/remote': {
        must_logged: true,
        component: Remote,
        right: 'remoteList',
        children: new Map({
            /** remote Detail */
            '/detail/:remoteId': {
                must_logged: true,
                component: RemoteDetails,
                right: 'remoteDetails'
            }
        })
    },

    '/issues': {
        must_logged: true,
        component: Issues,
        right: 'issuesList',
        children: new Map({
            '/:issueId/projects/:projectId': {
                must_logged: true,
                component: IssueDetails,
                right: 'issueDetails'
            },
            '/create': {
                must_logged: true,
                component: IssueCreate,
                right: 'issueCreate'
            }
        })
    },

    /** SDM20LHTs */
    '/SDM20LHT': {
        must_logged: true,
        component: SDM20LHT,
        right: 'SDM20LHTList',
        children: new Map({
            /** SDM20LHT Detail */
            '/detail/:SDM20LHTId': {
                must_logged: true,
                component: SDM20LHTDetails,
                right: 'SDM20LHTDetails'
            }
        })
    },

    /** Securities */
    '/securities': {
        must_logged: true,
        component: Security,
        right: 'securityList',
        children: new Map({
            /** Security Detail */
            '/detail/:securityId': {
                must_logged: true,
                component: SecurityDetails,
                right: 'securityDetails'
            }
        })
    }
});



// WEBPACK FOOTER //
// ./environments/myfhe/routes.js